import { RefObject } from "react";

enum StylingModalType {
  None,
  Border,
  Fill,
  TextColor,
}

const modalTypeToTitle: Record<StylingModalType, string> = {
  [StylingModalType.None]: "",
  [StylingModalType.Border]: "Border",
  [StylingModalType.Fill]: "",
  [StylingModalType.TextColor]: "Text Color",
};

type ModalState = {
  type: StylingModalType;
  anchor?: RefObject<HTMLElement>;
};

export type { ModalState };
export { modalTypeToTitle, StylingModalType };
